import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { SectionLabel, FadeUp } from "@/components/Reveal";
import Lightbox from "@/components/Lightbox";
import GalleryFrame from "@/components/GalleryFrame";
import { GALLERY_HOME } from "@/data/site";
import { track } from "@/lib/track";
import { useLang } from "@/i18n/LanguageContext";

const About = () => {
  const [lb, setLb] = useState(null);
  const { t } = useLang();
  const navLb = (d) =>
    setLb((i) => (i + d + GALLERY_HOME.length) % GALLERY_HOME.length);

  const images = GALLERY_HOME.map((img) => ({
    ...img,
    ...(t.gallery.images[img.key] || {}),
  }));

  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative overflow-hidden"
    >
      <img
        src="/images/stir/sketch-gallery.jpg"
        alt=""
        aria-hidden="true"
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover object-[50%_32%]"
      />
      <div className="absolute inset-0 bg-[#F4F0EA]/70 md:bg-[#F4F0EA]/60" aria-hidden="true" />

      <div className="relative mx-auto max-w-[1680px] px-6 py-20 lg:px-12 lg:py-32">
        <SectionLabel index="01" text={t.about.label} light />

        <FadeUp delay={0.1} className="mt-14">
          <GalleryFrame
            images={images}
            testid="gallery-frame"
            onOpen={(i) => {
              setLb(i);
              track("gallery_opened", { image: images[i].caption, location: "home" });
            }}
          />
        </FadeUp>

        <FadeUp delay={0.15}>
          <p
            data-testid="about-gallery-caption"
            className="mt-14 text-center font-serif text-2xl font-normal text-midnight md:text-3xl"
          >
            {t.gallery.pre}<span className="font-medium italic text-[#8a6f45]">{t.gallery.em}</span>{t.gallery.post}
          </p>
        </FadeUp>

        <FadeUp delay={0.2}>
          <h2 className="mx-auto mt-16 max-w-3xl text-center font-serif text-4xl font-light leading-[1.1] text-midnight md:text-5xl lg:mt-20">
            {t.about.pre}<span className="font-medium italic text-[#8a6f45]">{t.about.em}</span>{t.about.post}
          </h2>
        </FadeUp>
        <FadeUp delay={0.3}>
          <p className="mx-auto mt-8 max-w-xl text-center font-sans text-base font-normal leading-relaxed text-midnight/85">
            {t.about.body}
          </p>
        </FadeUp>
      </div>

      <AnimatePresence>
        {lb !== null && (
          <Lightbox
            images={images}
            index={lb}
            onClose={() => setLb(null)}
            onNav={navLb}
          />
        )}
      </AnimatePresence>
    </section>
  );
};

export default About;
